<template>
  <HeaderBlock />
  <div class="section_full_block">
    <div class="news_title_background"></div>
    <SocialMedia />
    <div class="box_title_home_pages">
      <h1 class="title color_white text_align_left">
        новости<br />
        <span class="margin_title1 color_white"> 7stars</span>
      </h1>
    </div>
  </div>
  <div class="news_container">
    <a class="news_block_link" href="">
      <div class="news_block">
        <img class="news_block_img1" src="@/assets/img/news1.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div>
    </a>
    <a class="news_block_link" href="">
      <div class="news_block">
        <img class="news_block_img1" src="@/assets/img/news2.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div>
    </a>
    <a class="news_block_link" href="">
      <div class="news_block">
        <img class="news_block_img1" src="@/assets/img/news3.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div></a
    >
    <a class="news_block_link" href="">
      <div class="news_block">
        <img class="news_block_img1" src="@/assets/img/news4.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div></a
    ><a class="news_block_link" href="">
      <div class="news_block">
        <img class="news_block_img1" src="@/assets/img/news5.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div></a
    ><a class="news_block_link" href="">
      <div class="news_block">
        <img class="news_block_img1" src="@/assets/img/news6.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div></a
    ><a class="news_block_link not_phone_news" href="">
      <div class="news_block not_phone_news">
        <img class="news_block_img1" src="@/assets/img/news7.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div></a
    ><a class="news_block_link not_phone_news" href="">
      <div class="news_block not_phone_news">
        <img class="news_block_img1" src="@/assets/img/news8.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div></a
    ><a class="news_block_link not_phone_news" href="">
      <div class="news_block not_phone_news">
        <img class="news_block_img1" src="@/assets/img/news9.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div></a
    ><a class="news_block_link not_phone_news" href="">
      <div class="news_block not_phone_news">
        <img class="news_block_img1" src="@/assets/img/news10.png" alt="" />
        <div class="news_text_block">
          <p class="news_block_date color_white">12 сентября 2024</p>
          <p class="news_block_question color_white">
            Что такое жидкость для вейпа и как её выбрать?
          </p>
          <p class="news_block_main_text">
            Электронные сигареты с каждым днем становятся все популярнее.
            Инновационное устройство позволяет получать...
          </p>
        </div>
        <button class="news_block_btn">подробнее</button>
      </div></a
    >
  </div>
  <div class="show_news_block_phone">
    <button class="show_news_button_phone">показать больше статей</button>
  </div>
  <TopLiest />
  <div class="propast"></div>
  <MakeorderBlock />
  <FooterBlock />
</template>

<script>
import HeaderBlock from "./stabl/HeaderBlock.vue";
import TopLiest from "./stabl/TopLiest.vue";
import MakeorderBlock from "./stabl/MakeorderBlock.vue";
import FooterBlock from "./stabl/FooterBlock.vue";
import SocialMedia from "@/components/UI/SocialMedia.vue";
export default {
  components: {
    HeaderBlock,
    TopLiest,
    MakeorderBlock,
    FooterBlock,
    SocialMedia,
  },
};
</script>
